import { useState } from 'react';
import classNames from 'classnames';

const Collapsible = ({title, defaultOpen, children}) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    const headingClass = classNames('heading', 'heading--md', 'heading--collapse', {
        'heading--collapse-open': isOpen,
    })

    return (
        <section className="section section--collapsible">
            <h3 className={headingClass} onClick={() => setIsOpen(!isOpen)}>{title}</h3>
            {isOpen ? (
                <div>
                    {children}
                </div>
            ) : null}
        </section>
    )
};

export default Collapsible;
